/// <amd-module name="Wit/WorkItemForm/Details/DiscussionMentionUtils" />

import { IVssPageContext } from "VSS/Platform/Context";
import { IVssPageService } from "VSS/Platform/Page";
import { IIdentity } from "VSSUI/Persona";
import { useStorageKeysInMentions } from "Mention/Common/Util";

const HTML_MENTION_VERSION_ATTR = "version";
const HTML_MENTION_ATTR_NAME = "data-vss-mention";
const HTML_MENTION_ID_ATTR = "id";
const METADATA_ATTR_SEPARATOR = ":";
const HTML_MENTION_LEGACY_HREF_ATTR = "mailto";
const HTML_MENTION_ID_ATTR_PREFIX = HTML_MENTION_ID_ATTR + METADATA_ATTR_SEPARATOR;
const HTML_MENTION_LEGACY_FORMAT_HREF = HTML_MENTION_LEGACY_HREF_ATTR + METADATA_ATTR_SEPARATOR;

export interface IIdentityMention {
    id: string;
    displayName: string;
}

export function createHtmlMention(pageContext: IVssPageContext, identity: IIdentity): string {
    if (!identity || !identity.displayName) {
        return "";
    }
    const displayName = identity.displayName;

    let version;
    let additionalMetadata;
    let href;

    if (useStorageKeysInMentions(pageContext)) {
        version = "2.0";
        additionalMetadata = identity.localId;
        href = "#";
    } else {
        version = "1.0";
        href = `${HTML_MENTION_LEGACY_FORMAT_HREF}${getIdentityId(pageContext, identity)}`;
        if (identity && identity.entityType === "Group") {
            if (identity.localId) {
                additionalMetadata = HTML_MENTION_ID_ATTR_PREFIX + identity.localId;
            }
        }
    }

    let metadata = HTML_MENTION_VERSION_ATTR + METADATA_ATTR_SEPARATOR + version;

    if (additionalMetadata) {
        metadata += "," + additionalMetadata;
    }

    const contentElement = document.createElement("a");
    contentElement.setAttribute("href", href);
    contentElement.setAttribute(HTML_MENTION_ATTR_NAME, metadata);
    contentElement.text = "@" + displayName;

    const result = contentElement.outerHTML + "&nbsp;";
    return result;
}

export function getIdentityId(pageContext: IVssPageContext, identity: IIdentity) {
    const pageData = pageContext.getService<IVssPageService>("IVssPageService").getData()!;
    if (pageData.isHosted) {
        if (useStorageKeysInMentions(pageContext)) {
            return identity.displayName;
        } else {
            return identity.signInAddress != null ? identity.signInAddress : identity.displayName;
        }
    }
    if (identity.entityType === "Group") {
        // Add '[' and ']' around the scope for groups.
        return `[${identity.scopeName}]\\${identity.samAccountName}`;
    }
    return `${identity.scopeName}\\${identity.samAccountName}`;
}
